export default {
    baseStyle: {
        container: {
            position: 'relative',
            width: '100%',
            borderRadius: '3px',
            padding: '15px 20px',
            backgroundColor: 'gray.50',
            fontSize: '23px',
            fontWeight: 400,
            color: 'teal.500',
            letterSpacing: '0.115px',
            sx: {
                a: {
                    textUnderlineOffset: 4,
                    textDecorationThickness: '1px !important',
                    textDecoration: 'underline'
                },
                'a.link-overlay': {
                    _after: {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    }
                },
                '.promo-acm-header': {
                    fontSize: '23px',
                    fontFamily: 'cormorant',
                    fontWeight: 400,
                    color: 'teal.500',
                    letterSpacing: '0.115px'
                },
                '.promo-acm-body': {
                    fontSize: '14px',
                    fontWeight: 300,
                    color: 'black.100',
                    lineHeight: '22px',
                    letterSpacing: '0.07px',
                    marginTop: '10px'
                },
                '.promo-acm-footer': {
                    fontSize: '14px',
                    fontWeight: 300,
                    color: 'gray.800',
                    lineHeight: '22px',
                    letterSpacing: '0.07px',
                    marginTop: '10px'
                }
            }
        }
    }
}
